export default __webpack_public_path__ + "static/media/str2.3ed3c657.svg";